import React from 'react';
import './../new_fonctionalites_2025.css'

const MySy_CRM_Section = () => {
  return (
    <div className='new_fonctionalites_2025 mysy_crm_section_block1'>
      {/* Right Image */}
      <div className='mysy_crm_section_block_image'>
        <img src="/img/fonctionnalite_img/img_crm.png" alt="Content illustration" className='contentsection_image' />
      </div>
      {/* Left Content Container */}
      <div className='mysy_crm_section_block_text'>
        {/* Title + Description Container */}
        <div className='mysy_crm_section_block_text_tite_desc'>
          {/* Title Section */}
          <div className='mysy_crm_section_block_text_tite_desc_title'>
            <span className='mysy_crm_section_block_text_tite_desc_title_span'>
              Gestion client (CRM)
            </span>
            <h1 className='mysy_crm_section_block_text_tite_desc_title_h1'>
              Gérez vos clients et optimisez votre activité
            </h1>
          </div>

          {/* Description */}
          <p className='mysy_crm_section_block_text_tite_desc_p'>
            Suivez en temps réel vos clients, vos activités en cours, à venir ou en retard. Ce module vous permet d'éditer et d'envoyer vos devis, de les convertir en commandes, puis de les facturer en toute simplicité.
            <br /><br />
            Grâce à un tableau de bord intuitif, visualisez vos revenus actuels et à venir pour prendre les meilleures décisions de gestion.  <br /><br />

          </p>
        </div>

        {/* Button */}
        <button className='mysy_crm_section_block_text_tite_desc_bton'
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#f5f5f5';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
          onClick={() => {
            window.open(
              "/tarif/",
              '_self'
            );
          }}
        >
          <span className='mysy_crm_section_block_text_tite_desc_bton_span'>
            Découvrez nos tarifs
          </span>
        </button>
      </div>


    </div>
  );
};

export default MySy_CRM_Section;

